import * as apiActions from "./apiActions";
import * as apiValues from "../constants/apiValues";
import * as pageActions from "./pageActions";


export const initPageProjects = () => (dispatch) => {
  dispatch(pageActions.loadPageStart());

  return apiActions.loadSingleType(apiValues.nref.pageProjects.endpoint)
    .then(result => {
      let page = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.pageProjects.fieldsUsed);
      page.intro = {
        title: page.title,
        description: page.description
      };
      page.projectListMap = {};
      return page;
    })
    .then(results => {
      return dispatch(pageActions.loadPageSuccess(results));
    })
    .catch(err => {
      console.error(err);
      return dispatch(pageActions.loadPageFail(err));
    });
};
